import { LazyImage, FacebookIcon, GroupWhatsappIcon, InstagramIcon, LocationIcon, OpenLinkIcon, ProductIcon, slugify, isValidLink} from '../../base'
import { useNavigate } from 'react-router-dom'
import { Stars } from '../index'

function ShopCard({ shop }) {
  const navigate = useNavigate()
console.log(shop)
  return (
    <div className='shopCard'>
      <LazyImage src={shop.image_1} alt={shop.shop_name} />
      <div className='detail'>
        <div className='h7 tcolor heading'>{shop.shop_name}</div>
        <div className='h7 text-center truncate-1'>{shop.heading}</div>
        <div className='d-flex h7' style={{ justifyContent: 'center', gap: '7px' }}><Stars rating={shop.avg_rating} reviews={shop.total_review} /></div>
        <div className='links'>
          <div className='singleLink ' onClick={() => navigate(`/shop/${slugify(shop.shop_name, shop.id, false)}/details/`)}><span><OpenLinkIcon /></span>Details</div>
          <div className='singleLink ' onClick={() => navigate(`/p/shop/${slugify(shop.shop_name)}/category/all/products/`)}><span><ProductIcon style={{ width: '23px' }} /></span>Products</div>
          <a href={isValidLink(shop.instagram_link).link} target={isValidLink(shop.instagram_link).target} className='singleLink'><span><InstagramIcon /></span>Instagram</a>
          <a href={isValidLink(shop.facebook_link).link} target={isValidLink(shop.facebook_link).target} className='singleLink '><span><FacebookIcon /></span>Facebook</a>
          <a href={isValidLink(shop.whatsapp_group_link).link} target={isValidLink(shop.whatsapp_group_link).target} className='singleLink '><span><GroupWhatsappIcon /></span>Whatsapp</a>
          <a href={isValidLink(shop.map_location).link} target={isValidLink(shop.map_location).target} className='singleLink '><span><LocationIcon style={{ width: '16px' }} /></span>Location</a>
        </div>
      </div>

    </div>
  )
}

export default ShopCard